<template>
  <BAutocomplete
    ref="autocomplete"
    v-bind="$attrs"
    item-text="name"
    item-value="id"
    label="Сервис"
    no-data-text="Сервис не найден"
    :request="request"
    v-on="$listeners"
  />
</template>

<script>
import { openApiMixin } from './mixins'
import { PermissionsApplicationsApi } from '@/api/resources'
import { Adapter } from '@/store/createCrudModule'

import BAutocomplete from '../BAutocomplete.vue'


export default {
  name: 'BAutocompletePermissionApplication',
  components: {
    BAutocomplete,
  },
  mixins: [
    openApiMixin,
  ],
  created() {
    const api = new PermissionsApplicationsApi()
    this.adapter = new Adapter(api)
  },
  methods: {
    request(...args) {
      return this.adapter.getAll(...args)
    },
  },
}
</script>
